import React from "react";
import { Box, IconButton, Typography, Tooltip } from "@mui/material";
import { Clear } from "@mui/icons-material";
import SaveAsDialog from "./SaveAsDialog/SaveAsDialog";
import { PopoverListButtons } from "../../../Utils/styledComps";

const CustomFilePopoverContent = ({ files, handlePopoverClose, open, setOpen }) => {
  const [saveAsOpen, setSaveAsOpen] = React.useState(false);
  return (
    <>
      <Box sx={{ height: 500, width: 315 }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 1.25,
          py: 1
        }}>
          <Typography variant="h6" sx={{ color: 'action.hover', fontWeight: 800 }}>
            File
          </Typography>
          <Tooltip title="Close menu" arrow>
            <IconButton
              edge="end"
              onClick={handlePopoverClose}
              aria-label="Close file menu"
              sx={{ borderRadius: 1 }}
            >
              <Clear />
            </IconButton>
          </Tooltip>
        </Box>

        <Box sx={{
          display: 'flex',
          gap: 1,
          m: 1.25,
          flexWrap: 'wrap'
        }}>
          {files.map((file, index) => (
            <Tooltip key={index} title={file.label} arrow placement="bottom">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: 60,
                  m: 0.625,
                  cursor: 'pointer',
                  color: 'action.hover',
                  transition: (theme) => theme.transitions.create(['transform'], {
                    duration: theme.transitions.duration.shorter,
                  }),
                  '&:hover': {
                    transform: 'translateY(-2px)',
                  },
                }}
                onClick={file.onClick}
              >
                <PopoverListButtons sx={{ p: 2 }} aria-label={file.label}>
                  {file.icon}
                </PopoverListButtons>
                <Typography
                  variant="caption"
                  sx={{
                    mt: 0.5,
                    textAlign: 'center',
                    fontSize: 11,
                    color: 'text.primary'
                  }}
                >
                  {file.label}
                </Typography>
              </Box>
            </Tooltip>
          ))}
        </Box>
      </Box>
      <SaveAsDialog
        open={open}
        setOpen={setOpen}
      />
    </>
  );
};

export default CustomFilePopoverContent;
